module.exports = __webpack_public_path__ + "static/media/03 Minutes of meeting 11 July 2023.a81e3a73.pdf";